export const LOCALE_SETTING = 'WEB_LOCALE';
export const PIP_EXPANDED_SETTING = 'WEB_PIP_EXPANDED';
export const FIRST_TIME_USER_SETTING = 'WEB_FIRST_TIME_USER';
export const SIDE_NAV_WIDE_SETTING = 'WEB_SIDE_NAV_WIDE';
